// Therapies subsection questionnaire constants
export enum TherapiesQuestionnaireItem {
  MEDICAL_BACKGROUND_THERAPIES = 'medical-background/therapies',
  MEDICAL_BACKGROUND_THERAPIES_THERAPIES = 'medical-background/therapies/therapies',
  MEDICAL_BACKGROUND_THERAPIES_THERAPY_PROVIDER = 'medical-background/therapies/therapy-provider',
  MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_PLAN = 'medical-background/therapies/home-exercise-plan',
  MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_DURATION = 'medical-background/therapies/home-exercise-duration',
  MEDICAL_BACKGROUND_THERAPIES_HOME_EXERCISE_FREQUENCY = 'medical-background/therapies/home-exercise-frequency'
}
